import Model from '@/shared/orm/Model'

export default class BaseModel extends Model {}
